// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#assistant-product-recommendations-efzk .v-application .gc-product-tile-wrapper ul{list-style:initial;font-size:medium}#assistant-product-recommendations-efzk .v-application .gc-product-tile-wrapper .pl-3{padding-left:1rem!important}#assistant-product-recommendations-efzk .v-application .gc-product-tile-wrapper .pb-3{padding-bottom:1rem!important}#assistant-product-recommendations-efzk .gc-product-tile-wrapper .gc-tile-standard{width:100%}", ""]);
// Exports
module.exports = exports;
